import { Button } from 'antd-mobile'
import React from 'react'
import './empty-page.less'

export default class EmptyPage extends React.Component<any, any> {



  render() {
    const {img, title, brief, btnTitle, btnClick} = this.props
    return (
      <div className="empty-page" style={{height: document.documentElement.scrollHeight}}>
        <img src={img ? img : '/public/assets/img/empty_icon.png'} alt=""/>
        {title ? <span style={{color: '#666666', fontSize: '16px', fontWeight: 'bold'}}>{title}</span> : null}
        {brief ? <span style={{color: '#cccccc', fontSize: '12px', marginTop: '20px'}}>{brief}</span> : null}
        {btnTitle ? <Button style={{marginTop: '20px'}} type="warning" size="small" onClick={btnClick}>{btnTitle}</Button> : null}
      </div>
    )
  }
}